// Hero slideshow slider js

document.addEventListener('DOMContentLoaded', function () {
  var herosliderSwipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      // Block left–right only
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  // Hide/show odd slides based on slidesPerView
  function handleOddSlides(swiper) {
    if (swiper.params.slidesPerView === 1) {
      swiper.slides.forEach(function (slide, index) {
        if (index % 2 === 0) {
          slide.style.display = "none";
        } else {
          slide.style.display = "";
        }
      });
    } else {
      swiper.slides.forEach(function (slide) {
        slide.style.display = "";
      });
    }
    swiper.update();
  }

  function initherosliderSwiper(swiperContainer) {

    // 🔑 ADDITION
    blockMouseScroll(swiperContainer);

    // Pre-hide odd slides if window < 768
    if (window.innerWidth < 768) {
      swiperContainer
        .querySelectorAll('.swiper-slide:nth-child(odd)')
        .forEach(function (slide) {
          slide.style.display = "none";
        });
    }

    var herosliderSwiper = new Swiper(swiperContainer, {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10,
      loop: false,
      autoplay: false,
      speed: 800,
      grabCursor: true,

      mousewheel: false,
      simulateTouch: false,
      allowTouchMove: false,

      navigation: {
        nextEl: swiperContainer.querySelector(".slider-swiper-button-next"),
        prevEl: swiperContainer.querySelector(".slider-swiper-button-prev")
      },

      pagination: {
        el: swiperContainer.querySelector(".slider-swiper-pagination"),
        clickable: true,
        type: 'fraction'
      },

      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 2,
          spaceBetween: 5,
          allowTouchMove: true   // 📱 mobile swipe ON
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 5,
          allowTouchMove: false
        },
        992: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 10,
          allowTouchMove: false
        }
      },

      on: {
        init: function () {
          handleOddSlides(this);
          this.el.style.opacity = '1';
        },
        resize: function () {
          handleOddSlides(this);
        }
      }
    });

    herosliderSwipers.push(herosliderSwiper);
  }

  // Initialize Hero slider Swiper on page load
  document.querySelectorAll('.classic-container').forEach(function (swiperContainer) {
    initherosliderSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
    herosliderSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    herosliderSwipers = [];
    document.querySelectorAll('.classic-container').forEach(function (swiperContainer) {
      initherosliderSwiper(swiperContainer);
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    herosliderSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    herosliderSwipers = [];
  });
});

// featured collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedcollectionSwipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initFeaturedcollectionSwiper(swiperContainer) {
    var enable = swiperContainer.dataset.enable;
    var desktopspace = swiperContainer.dataset.desktopspace;
    var mobilespace = swiperContainer.dataset.mobilespace;
    var desktop = swiperContainer.dataset.desktop;
    var largeTablet = swiperContainer.dataset.largetablet;
    var tablet = swiperContainer.dataset.tablet;
    var mobile = swiperContainer.dataset.mobile;

    if (enable) {

      // 🔑 ADD HERE
      blockMouseScroll(swiperContainer);

      var FeaturedcollectionSwiper = new Swiper(swiperContainer, {
        slidesPerView: desktop,
        spaceBetween: desktopspace,
        loop: true,
        autoplay: false,
        speed: 600,
        grabCursor: true,
        a11y: false,

        // ❌ scroll / swipe disable on laptop
        mousewheel: false,
        simulateTouch: false,
        allowTouchMove: false,

        navigation: {
          nextEl: swiperContainer.querySelector(".featured-swiper-button-next"),
          prevEl: swiperContainer.querySelector(".featured-swiper-button-prev")
        },

        pagination: {
          el: swiperContainer.querySelector(".featured-swiper-pagination"),
          clickable: true,
          type: 'fraction'
        },

        // 📱 Mobile swipe ON
        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: mobilespace,
            allowTouchMove: true
          },
          576: {
            slidesPerView: tablet,
            spaceBetween: mobilespace,
            allowTouchMove: true
          },
          841: {
            slidesPerView: largeTablet,
            spaceBetween: mobilespace,
            allowTouchMove: false
          },
          992: {
            slidesPerView: desktop,
            spaceBetween: desktopspace,
            allowTouchMove: false
          }
        },

        on: {
          init: function () {
            this.el.style.opacity = '1';
          }
        }
      });

      FeaturedcollectionSwipers.push(FeaturedcollectionSwiper);
    }
  }

  // Initialize Featured collection Swiper on page load
  document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
    initFeaturedcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
    FeaturedcollectionSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    FeaturedcollectionSwipers = [];

    document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
      initFeaturedcollectionSwiper(swiperContainer);
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    FeaturedcollectionSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    FeaturedcollectionSwipers = [];
  });
});

// tab collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var TabcollectionSwipers = [];

  function initTabcollectionSwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;

    if (enable) {
      var TabcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: true,
          autoplay: false,
          speed: 600,
          grabCursor: true,
          a11y: false,
          navigation: false,
          pagination: false,
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
        on: {
          init: function () {
            this.el.style.opacity = '1';
          }
        }
      });

      TabcollectionSwipers.push(TabcollectionSwiper);
    }
  }

  // Initialize Tab collection Swiper on page load
  document.querySelectorAll('.tab-slider').forEach(function (swiperContainer) {
      initTabcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Tab collection Swiper on section select
      TabcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TabcollectionSwipers = [];
      document.querySelectorAll('.tab-slider').forEach(function (swiperContainer) {
          initTabcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Tab collection Swiper on section deselect if necessary
      TabcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TabcollectionSwipers = [];
  });
});

// category collection style 2 slider

document.addEventListener('DOMContentLoaded', function () {
  var categorycollection2Swipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initcategorycollection2Swiper(swiperContainer) {
    var desktopspace = swiperContainer.dataset.desktopspace;
    var mobilespace = swiperContainer.dataset.mobilespace;

    // 🔑 ADD HERE
    blockMouseScroll(swiperContainer);

    var categorycollection2Swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: desktopspace,
      loop: true,
      autoplay: false,
      speed: 800,
      grabCursor: true,
      a11y: false,

      // ❌ Laptop scroll / swipe OFF
      mousewheel: false,
      simulateTouch: false,
      allowTouchMove: false,

      navigation: {
        nextEl: swiperContainer.querySelector(".category-style2-swiper-button-next"),
        prevEl: swiperContainer.querySelector(".category-style2-swiper-button-prev")
      },

      pagination: {
        el: swiperContainer.querySelector(".category-style2-swiper-pagination"),
        clickable: true,
        type: 'fraction'
      },

      // 📱 Mobile swipe ON
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: mobilespace,
          allowTouchMove: true
        },
        480: {
          slidesPerView: 1,
          spaceBetween: mobilespace,
          allowTouchMove: true
        },
        841: {
          slidesPerView: 1,
          spaceBetween: mobilespace,
          allowTouchMove: false
        },
        992: {
          slidesPerView: 1,
          spaceBetween: desktopspace,
          allowTouchMove: false
        }
      },

      on: {
        init: function () {
          this.el.style.opacity = '1';
        }
      }
    });

    categorycollection2Swipers.push(categorycollection2Swiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.main-collections-style2-list-wrapper').forEach(function (swiperContainer) {
    initcategorycollection2Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
    categorycollection2Swipers.forEach(function (swiper) {
      swiper.destroy();
    });
    categorycollection2Swipers = [];

    document.querySelectorAll('.main-collections-style2-list-wrapper').forEach(function (swiperContainer) {
      initcategorycollection2Swiper(swiperContainer);
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    categorycollection2Swipers.forEach(function (swiper) {
      swiper.destroy();
    });
    categorycollection2Swipers = [];
  });
});

// blog slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedblogSwipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initFeaturedblogSwiper(swiperContainer) {

    // 🔑 ADD HERE
    blockMouseScroll(swiperContainer);

    var FeaturedblogSwiper = new Swiper(swiperContainer, {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: false,
      autoplay: false,
      speed: 600,
      grabCursor: true,
      a11y: false,

      // ❌ Laptop scroll / swipe OFF
      mousewheel: false,
      simulateTouch: false,
      allowTouchMove: false,

      navigation: {
        nextEl: swiperContainer.querySelector(".blog-swiper-button-next"),
        prevEl: swiperContainer.querySelector(".blog-swiper-button-prev")
      },

      pagination: {
        el: swiperContainer.querySelector(".blog-swiper-pagination"),
        clickable: true,
        type: 'fraction'
      },

      // 📱 Mobile swipe ON
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 5,
          allowTouchMove: true
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 5,
          allowTouchMove: true
        },
        841: {
          slidesPerView: 2,
          spaceBetween: 5,
          allowTouchMove: false
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 10,
          allowTouchMove: false
        }
      },

      on: {
        init: function () {
          this.el.style.opacity = '1';
        }
      }
    });

    FeaturedblogSwipers.push(FeaturedblogSwiper);
  }

  // Initialize Featured blog Swiper on page load
  document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
    initFeaturedblogSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
    FeaturedblogSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    FeaturedblogSwipers = [];

    document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
      initFeaturedblogSwiper(swiperContainer);
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    FeaturedblogSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    FeaturedblogSwipers = [];
  });
});

// multicolumn slider js

document.addEventListener('DOMContentLoaded', function () {
  var MulticolumnSwipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initmulticolumnSwiper(swiperContainer) {
    var desktopspace = swiperContainer.dataset.desktopspace;
    var mobilespace = swiperContainer.dataset.mobilespace;

    // 🔑 ADD HERE
    blockMouseScroll(swiperContainer);

    var MulticolumnSwiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: desktopspace,
      loop: true,
      autoplay: false,
      speed: 600,
      grabCursor: true,
      a11y: false,

      // ❌ Laptop scroll / swipe OFF
      mousewheel: false,
      simulateTouch: false,
      allowTouchMove: false,

      navigation: {
        nextEl: swiperContainer.querySelector(".multicolumn-swiper-button-next"),
        prevEl: swiperContainer.querySelector(".multicolumn-swiper-button-prev")
      },

      pagination: {
        el: swiperContainer.querySelector(".multicolumn-swiper-pagination"),
        clickable: true,
        type: 'fraction'
      },

      // 📱 Mobile swipe ON
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: mobilespace,
          allowTouchMove: true
        },
        576: {
          slidesPerView: 1,
          spaceBetween: mobilespace,
          allowTouchMove: true
        },
        841: {
          slidesPerView: 1,
          spaceBetween: mobilespace,
          allowTouchMove: false
        },
        992: {
          slidesPerView: 1,
          spaceBetween: desktopspace,
          allowTouchMove: false
        }
      },

      on: {
        init: function () {
          this.el.style.opacity = '1';
        }
      }
    });

    MulticolumnSwipers.push(MulticolumnSwiper);
  }

  // Initialize Multicolumn Swiper on page load
  document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
    initmulticolumnSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
    MulticolumnSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    MulticolumnSwipers = [];

    document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
      initmulticolumnSwiper(swiperContainer);
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    MulticolumnSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    MulticolumnSwipers = [];
  });
});

// recentview collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var recentviewcollectionSwipers = [];

  // 🔥 block ONLY left-right scroll (vertical allow)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initrecentviewcollectionSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;

      // 🔑 ADD HERE
      blockMouseScroll(swiperContainer);

      var recentviewcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: true,
          autoplay: false,
          speed: 600,
          grabCursor: true,
          a11y: false,

          // ❌ laptop / touchpad swipe OFF
          mousewheel: false,
          simulateTouch: false,
          allowTouchMove: false,

          navigation: {
              nextEl: swiperContainer.querySelector(".recent-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".recent-swiper-button-prev")
          },

          pagination: {
              el: swiperContainer.querySelector(".recent-swiper-pagination"),
              clickable: true,
              type: 'fraction'
          },

          // 📱 mobile swipe ON
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace,
                allowTouchMove: true
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace,
                allowTouchMove: true
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace,
                allowTouchMove: false
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
                allowTouchMove: false
            }
          },

          on: {
            init: function () {
              this.el.style.opacity = '1';
            }
          }
      });

      recentviewcollectionSwipers.push(recentviewcollectionSwiper);
  }

  // Initialize Recent View Swiper on page load
  document.querySelectorAll('.recent-slider').forEach(function (swiperContainer) {
      initrecentviewcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      recentviewcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      recentviewcollectionSwipers = [];

      document.querySelectorAll('.recent-slider').forEach(function (swiperContainer) {
          initrecentviewcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      recentviewcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      recentviewcollectionSwipers = [];
  });
});

// About Us style1 slider js

document.addEventListener('DOMContentLoaded', function () {
  var AboutUsStyle1Swipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initAboutUsStyle1Swiper(swiperContainer) {

      // 🔑 ADD HERE
      blockMouseScroll(swiperContainer);

      var AboutUsStyle1Swiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: false,
          speed: 600,
          grabCursor: true,
          a11y: false,

          // ❌ Laptop swipe OFF
          mousewheel: false,
          simulateTouch: false,
          allowTouchMove: false,

          navigation: {
              nextEl: swiperContainer.querySelector(".about-style1-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".about-style1-swiper-button-prev")
          },

          pagination: {
              el: swiperContainer.querySelector(".about-style1-swiper-pagination"),
              clickable: true,
              type: 'fraction'
          }
      });

      AboutUsStyle1Swipers.push(AboutUsStyle1Swiper);
  }

  // Initialize About Us Style1 Swiper on page load
  document.querySelectorAll('.about_style1-main-slider').forEach(function (swiperContainer) {
      initAboutUsStyle1Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      AboutUsStyle1Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      AboutUsStyle1Swipers = [];
      document.querySelectorAll('.about_style1-main-slider').forEach(function (swiperContainer) {
          initAboutUsStyle1Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      AboutUsStyle1Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      AboutUsStyle1Swipers = [];
  });
});

// Project section slider js

document.addEventListener('DOMContentLoaded', function () {
  var ProjectSectionSwipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initProjectSectionSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;

      // 🔑 ADD HERE
      blockMouseScroll(swiperContainer);

      var ProjectSectionSwiper = new Swiper(swiperContainer, {
          spaceBetween: desktopspace,
          slidesPerView: 1.4,
          centeredSlides: true,
          loop: true,
          autoplay: false,
          speed: 600,
          grabCursor: true,
          a11y: false,

          // ❌ laptop / touchpad swipe OFF
          mousewheel: false,
          simulateTouch: false,
          allowTouchMove: false,

          navigation: {
              nextEl: swiperContainer.querySelector(".project-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".project-swiper-button-prev")
          },

          pagination: {
              el: swiperContainer.querySelector(".project-swiper-pagination"),
              clickable: true,
              type: 'fraction'
          },

          // 📱 Mobile swipe ON
          breakpoints: {
              320: {
                  slidesPerView: 1.3,
                  spaceBetween: mobilespace,
                  allowTouchMove: true
              },
              480: {
                  slidesPerView: 1.3,
                  spaceBetween: mobilespace,
                  allowTouchMove: true
              },
              841: {
                  slidesPerView: 1.3,
                  spaceBetween: mobilespace,
                  allowTouchMove: false
              },
              992: {
                  slidesPerView: 1.4,
                  spaceBetween: desktopspace,
                  allowTouchMove: false
              },
          },

          on: {
            init: function () {
              this.el.style.opacity = '1';
            }
          }
      });

      ProjectSectionSwipers.push(ProjectSectionSwiper);
  }

  // Initialize all sliders
  document.querySelectorAll('.project-stories-slider').forEach(function (swiperContainer) {
      initProjectSectionSwiper(swiperContainer);
  });

  // Reinitialize on Shopify section select
  document.addEventListener('shopify:section:select', function () {
      ProjectSectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ProjectSectionSwipers = [];
      document.querySelectorAll('.project-stories-slider').forEach(function (swiperContainer) {
          initProjectSectionSwiper(swiperContainer);
      });
  });

  // Destroy on section deselect
  document.addEventListener('shopify:section:deselect', function () {
      ProjectSectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ProjectSectionSwipers = [];
  });
});

// Lookbook banner slider js

document.addEventListener('DOMContentLoaded', function () {
  var LookBookBannerSwipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initLookBookBannerSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;

      // 🔑 ADD HERE
      blockMouseScroll(swiperContainer);

      var LookBookBannerSwiper = new Swiper(swiperContainer, {
          slidesPerView: 3,
          spaceBetween: desktopspace,
          loop: false,
          autoplay: false,
          speed: 600,
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.4,
          },
          grabCursor: true,
          a11y: false,

          // ❌ Laptop swipe OFF
          mousewheel: false,
          simulateTouch: false,
          allowTouchMove: false,

          navigation: {
              nextEl: swiperContainer.querySelector(".lookbook-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".lookbook-swiper-button-prev")
          },

          pagination: {
              el: swiperContainer.querySelector(".lookbook-swiper-pagination"),
              clickable: true,
              type: 'fraction'
          },

          // 📱 Mobile swipe ON
          breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: mobilespace,
                allowTouchMove: true
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: mobilespace,
                allowTouchMove: true
            },
            841: {
                slidesPerView: 2,
                spaceBetween: mobilespace,
                allowTouchMove: false
            },
            992: {
                slidesPerView: 3,
                spaceBetween: desktopspace,
                allowTouchMove: false
            },
        },

        on: {
          init: function () {
            this.el.style.opacity = '1';
          }
        }
      });

      LookBookBannerSwipers.push(LookBookBannerSwiper);
  }

  // Initialize Lookbook banner Swiper on page load
  document.querySelectorAll('.main-lookbook-section-wrapper').forEach(function (swiperContainer) {
      initLookBookBannerSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      LookBookBannerSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      LookBookBannerSwipers = [];
      document.querySelectorAll('.main-lookbook-section-wrapper').forEach(function (swiperContainer) {
          initLookBookBannerSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      LookBookBannerSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      LookBookBannerSwipers = [];
  });
});

// Project builder slider
document.addEventListener('DOMContentLoaded', function () {
  var ProjectbuilderSwipers = [];

  function enableSwiperClasses(swiperContainer) {
    swiperContainer.classList.add("swiper-container");
    var wrapper = swiperContainer.querySelector(".project-list");
    wrapper.classList.add("swiper-wrapper");
    wrapper.classList.remove("grid", "grid--2-col-desktop", "grid--3-col-desktop", "grid--4-col-desktop");
    wrapper.querySelectorAll(".main-project-list").forEach(function (slide) {
      slide.classList.add("swiper-slide");
      slide.classList.remove("grid__item");
    });
  }

  function enableGridClasses(swiperContainer) {
    swiperContainer.classList.remove("swiper-container");
    var wrapper = swiperContainer.querySelector(".project-list");
    wrapper.classList.remove("swiper-wrapper");
    wrapper.classList.add(
      "product-grid",
      "contains-card",
      "contains-card--product",
      "grid",
      `grid--${swiperContainer.dataset.desktop}-col-desktop`,
      `grid--${swiperContainer.dataset.largetablet}-col-large-tab`,
      `grid--${swiperContainer.dataset.tablet}-col-tab`,
      `grid--${swiperContainer.dataset.mobile}-col-mobile`
    );
    wrapper.querySelectorAll(".main-project-list").forEach(function (slide) {
      slide.classList.remove("swiper-slide");
      slide.classList.add("grid__item");
    });
  }

  function initPagebuilderSwiper(swiperContainer) {
    var enableMobile = swiperContainer.dataset.enableMobile === "true";

    if (enableMobile && window.innerWidth <= 991) {
      enableSwiperClasses(swiperContainer);

      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;

      var categorycollection1Swiper = new Swiper(swiperContainer, {
        slidesPerView: mobile,
        spaceBetween: mobilespace,
        loop: true,
        autoplay: false,
        speed: 600,
        grabCursor: true,
        a11y: false,
        navigation: {
          nextEl: swiperContainer.querySelector(".project-builder-swiper-button-next"),
          prevEl: swiperContainer.querySelector(".project-builder-swiper-button-prev")
        },
        pagination: {
          el: swiperContainer.querySelector(".project-builder-swiper-pagination"),
          clickable: true,
          type: 'fraction'
        },
        breakpoints: {
          320: { 
            slidesPerView: mobile,
            spaceBetween: mobilespace
          },
          576: { 
            slidesPerView: tablet,
            spaceBetween: mobilespace
          },
          841: {
            slidesPerView: largeTablet,
            spaceBetween: mobilespace
          },
          992: { 
            slidesPerView: desktop,
            spaceBetween: desktopspace
          },
        },
      });

      ProjectbuilderSwipers.push(categorycollection1Swiper);
    } else {
      enableGridClasses(swiperContainer);
    }
  }

  function destroyAllSwipers() {
    ProjectbuilderSwipers.forEach(function (swiper) {
      if (swiper && swiper.destroy) swiper.destroy();
    });
    ProjectbuilderSwipers = [];
  }

  function initAll() {
    destroyAllSwipers();
    document.querySelectorAll('.project-builder-list-wrappers').forEach(function (swiperContainer) {
      initPagebuilderSwiper(swiperContainer);
    });
  }

  initAll();
  window.addEventListener('resize', initAll);

  document.addEventListener('shopify:section:select', initAll);
  document.addEventListener('shopify:section:deselect', destroyAllSwipers);
});

// Related products 2 slider js

document.addEventListener('DOMContentLoaded', function () {
  var RelatedProducts2Swipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initRelatedProducts2Swiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;

      // 🔑 ADD HERE
      blockMouseScroll(swiperContainer);

      var RelatedProducts2Swiper = new Swiper(swiperContainer, {
          spaceBetween: desktopspace,
          slidesPerView: 1.4,
          centeredSlides: true,
          loop: true,
          autoplay: false,
          speed: 600,
          grabCursor: true,
          a11y: false,

          // ❌ laptop / touchpad swipe OFF
          mousewheel: false,
          simulateTouch: false,
          allowTouchMove: false,

          navigation: {
              nextEl: swiperContainer.querySelector(".related-products2-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".related-products2-swiper-button-prev")
          },

          pagination: false,

          // 📱 Mobile swipe ON
          breakpoints: {
              320: {
                  slidesPerView: 1.3,
                  spaceBetween: mobilespace,
                  allowTouchMove: true
              },
              480: {
                  slidesPerView: 1.3,
                  spaceBetween: mobilespace,
                  allowTouchMove: true
              },
              841: {
                  slidesPerView: 1.3,
                  spaceBetween: mobilespace,
                  allowTouchMove: false
              },
              992: {
                  slidesPerView: 1.4,
                  spaceBetween: desktopspace,
                  allowTouchMove: false
              },
          },

          on: {
            init: function () {
              this.el.style.opacity = '1';
            }
          }
      });

      RelatedProducts2Swipers.push(RelatedProducts2Swiper);
  }

  // Initialize all sliders
  document.querySelectorAll('.related-products2-slider').forEach(function (swiperContainer) {
      initRelatedProducts2Swiper(swiperContainer);
  });

  // Reinitialize on Shopify section select
  document.addEventListener('shopify:section:select', function () {
      RelatedProducts2Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      RelatedProducts2Swipers = [];
      document.querySelectorAll('.related-products2-slider').forEach(function (swiperContainer) {
          initRelatedProducts2Swiper(swiperContainer);
      });
  });

  // Destroy on section deselect
  document.addEventListener('shopify:section:deselect', function () {
      RelatedProducts2Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      RelatedProducts2Swipers = [];
  });
});

// navigation menu product slider megamenu
document.addEventListener('DOMContentLoaded', function () {
  var menuSwipers = [];

  function initTabcollectionSwiper(swiperContainer) {
    var TabcollectionSwiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: false,
      speed: 600,
      grabCursor: true,
      a11y: false,
      breakpoints: {
          320: {
              slidesPerView: 2,
              spaceBetween: 10
          },
          992: {
              slidesPerView: 1,
              spaceBetween: 10
          },
      },
    });

    menuSwipers.push(TabcollectionSwiper);
  }

  // Initialize Tab collection Swiper on page load
  document.querySelectorAll('.menu1-slider').forEach(function (swiperContainer) {
    initTabcollectionSwiper(swiperContainer);
  });

  // Reinitialize on section select
  document.addEventListener('shopify:section:select', function () {
    menuSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    menuSwipers = [];
    document.querySelectorAll('.menu1-slider').forEach(function (swiperContainer) {
      initTabcollectionSwiper(swiperContainer);
    });
  });

  // Cleanup on section deselect
  document.addEventListener('shopify:section:deselect', function () {
    menuSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    menuSwipers = [];
  });
});

// Video with text slider js

document.addEventListener('DOMContentLoaded', function () {
  var VideoproductSwipers = [];

  // 🔥 ONLY horizontal scroll block (vertical allowed)
  function blockMouseScroll(container) {
    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  function initVideoproductSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;

      // 🔑 ADD HERE
      blockMouseScroll(swiperContainer);

      var VideoproductSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: true,
          autoplay: false,
          speed: 600,
          grabCursor: true,
          a11y: false,

          // ❌ Laptop swipe OFF
          mousewheel: false,
          simulateTouch: false,
          allowTouchMove: false,

          navigation: {
              nextEl: swiperContainer.querySelector(".videoproduct-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".videoproduct-swiper-button-prev")
          },

          pagination: {
              el: swiperContainer.querySelector(".videoproduct-swiper-pagination"),
              clickable: true,
              type: 'fraction'
          },

          // 📱 Mobile swipe ON
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace,
                allowTouchMove: true
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: mobilespace,
                allowTouchMove: true
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace,
                allowTouchMove: false
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
                allowTouchMove: false
            },
        },

        on: {
          init: function () {
            this.el.style.opacity = '1';
          }
        }
      });

      VideoproductSwipers.push(VideoproductSwiper);
  }

  // Initialize Videoproduct collection Swiper on page load
  document.querySelectorAll('.video-product-slider').forEach(function (swiperContainer) {
      initVideoproductSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      VideoproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      VideoproductSwipers = [];
      document.querySelectorAll('.video-product-slider').forEach(function (swiperContainer) {
          initVideoproductSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      VideoproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      VideoproductSwipers = [];
  });
});